/**
 * The Set up Accounting stepper's strings (piece 23; T1191, decision 2535), kept
 * beside its rules and spread into the one lookup in `strings.ts`. 🔨 This file
 * imports nothing, because the lookup imports it.
 */
export const ACCOUNTING_SETUP_STEPS_STRINGS = {
  'accounting.steps.title': 'Set Up Accounting',
  'accounting.steps.hint': 'Three steps to finish before the first shipment and the first invoice. A step ticks itself once what it asks for is saved.',
  'accounting.steps.costBasis.title': 'Choose what stock is costed at',
  'accounting.steps.costBasis.body': 'FIFO or Weighted Average, from a date. The first shipment is refused until one is chosen, so choose it before any stock leaves the shelf.',
  'accounting.steps.costBasis.done': 'The cost basis is chosen.',
  'accounting.steps.costBasis.open': 'Open the Cost Basis',
  'accounting.steps.reportingBasis.title': 'Choose the reporting basis',
  'accounting.steps.reportingBasis.body': 'Accrual or Cash, the basis every report opens on. Save it once, even where the default suits.',
  'accounting.steps.reportingBasis.done': 'The reporting basis is saved.',
  'accounting.steps.reportingBasis.open': 'Open the Reporting Basis',
  'accounting.steps.openingBalances.title': 'Bring in the opening balances',
  'accounting.steps.openingBalances.body': 'The Zoho Books import posts one opening entry as at the day before the books start here. A book that never ran it sets each account’s opening with Set Opening Balance on that account’s page. Skip this on a company that starts from nothing.',
  'accounting.steps.openingBalances.done': 'The ledger is open: an opening entry stands, or the books had nothing to post the day before they start here.',
  'accounting.steps.openingBalances.open': 'Open the Import',
  // 🔒 Decision 10120: the second place the step is done, each account's own page in the Chart of Accounts.
  'accounting.steps.openingBalances.openChart': 'Open the Chart of Accounts',
} as const;
